import { useSelector } from 'react-redux';
import Modal from './modalNEW';
import styled from 'styled-components';

const IFrame = styled.iframe`
  border: none;
`;

const iframeModal = () => {
  const { src, height } = useSelector((state: any) => state.modal.modalProps.iframe);
  return (
    <Modal>
      <IFrame height={height} src={src}
        width="100%"/>
    </Modal>
  );
};
export default iframeModal;
